export function validateState(schema, data) {
    const result = schema.safeParse(data);
    if (result.success) {
        return {
            success: true,
            data: result.data,
            error: null
        };
    }
    return {
        success: false,
        data: null,
        error: result.error
    };
}
